import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import {
  listCustomerAddresses,
  // getCustomerAddress,
  // getCustomerAddressDefault,
  addCustomerAddress,
  editCustomerAddress,
  deleteCustomerAddress
} from './api';
import {
  LIST_CUSTOMER_ADDRESSES_REQUEST,
  // GET_CUSTOMER_ADDRESS_REQUEST,
  GET_CUSTOMER_ADDRESS_SUCCESS,
  CUSTOMER_ADDRESS_OBJECT_REQUESTING,
  CUSTOMER_ADDRESS_LIST_REQUESTING,
  LIST_CUSTOMER_ADDRESSES_SUCCESS,
  RESET_CUSTOMER_ADDRESS_ISFETCHING,
  ADD_CUSTOMER_ADDRESS_REQUEST,
  EDIT_CUSTOMER_ADDRESS_REQUEST,
  DELETE_CUSTOMER_ADDRESS_REQUEST,
  DELETE_CUSTOMER_ADDRESS_SUCCESS
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_ADDRESS_LIST_REQUESTING });
    const response = yield call(listCustomerAddresses, action.queryString);
    yield put({
      type: LIST_CUSTOMER_ADDRESSES_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_ADDRESS_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* add(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_ADDRESS_OBJECT_REQUESTING });
    const response = yield call(addCustomerAddress, action.customerAddress);
    yield put({
      type: GET_CUSTOMER_ADDRESS_SUCCESS,
      payload: response.data
    });
    yield call(list, {});
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_ADDRESS_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* edit(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_ADDRESS_OBJECT_REQUESTING });
    const response = yield call(
      editCustomerAddress,
      action.customerAddressId,
      action.data
    );
    yield put({
      type: GET_CUSTOMER_ADDRESS_SUCCESS,
      payload: response.data
    });
    yield call(list, {});
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_ADDRESS_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* deleteObj(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_ADDRESS_OBJECT_REQUESTING });
    const response = yield call(
      deleteCustomerAddress,
      action.customerAddressId
    );
    yield put({
      type: DELETE_CUSTOMER_ADDRESS_SUCCESS,
      payload: { id: action.customerAddressId }
    });
    yield call(list, {});
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_ADDRESS_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* watchList() {
  yield takeLatest(LIST_CUSTOMER_ADDRESSES_REQUEST, list);
  //   yield takeLatest(GET_CUSTOMER_ADDRESS_REQUEST, get);
  yield takeLatest(ADD_CUSTOMER_ADDRESS_REQUEST, add);
  yield takeLatest(EDIT_CUSTOMER_ADDRESS_REQUEST, edit);
  yield takeLatest(DELETE_CUSTOMER_ADDRESS_REQUEST, deleteObj);
}

export default function* customerAddressSagas() {
  yield all([watchList()]);
}
